

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class EventPhaseItem_ManagedObject

class EventPhaseItem_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: concept
    set concept(value:string) {
        this.setValueForKey(value, 'concept');
    }
    get concept():string {
        return this.valueForKey('concept');
    }
    set conceptPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'concept');
    }
    get conceptPrimitiveValue():string {
        return this.primitiveValueForKey('concept');
    }

    // Property: quantity
    set quantity(value:number) {
        this.setValueForKey(value, 'quantity');
    }
    get quantity():number {
        return this.valueForKey('quantity');
    }
    set quantityPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'quantity');
    }
    get quantityPrimitiveValue():number {
        return this.primitiveValueForKey('quantity');
    }

    // Property: totalAmount
    set totalAmount(value:number) {
        this.setValueForKey(value, 'totalAmount');
    }
    get totalAmount():number {
        return this.valueForKey('totalAmount');
    }
    set totalAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'totalAmount');
    }
    get totalAmountPrimitiveValue():number {
        return this.primitiveValueForKey('totalAmount');
    }

    // Property: unitPrice
    set unitPrice(value:number) {
        this.setValueForKey(value, 'unitPrice');
    }
    get unitPrice():number {
        return this.valueForKey('unitPrice');
    }
    set unitPricePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'unitPrice');
    }
    get unitPricePrimitiveValue():number {
        return this.primitiveValueForKey('unitPrice');
    }
    // Relationship: phase
    set phase(value:EventPhase) {
        this.setValueForKey(value, 'phase');
    }
    get phase():EventPhase {
        return this.valueForKey('phase') as EventPhase;
    }
}
